import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { SpecialtySliceService } from "../api";

export const actionGetListSpecialty = createAsyncThunk(
  "common/list-specialty",
  async (keyword, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doGetListSpecialty(keyword);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListMedicalFacility = createAsyncThunk(
  "common/list-medical-facility",
  async (keyword, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doGetListMedicalFacility(keyword);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetDetailMedicalFacility = createAsyncThunk(
  "common/detail-medical-facility",
  async (facilityId, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doGetDetailMedicalFacility(
        facilityId
      );
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetDetailDoctorSpecialty = createAsyncThunk(
  "common/detail-doctor-specialty",
  async (data, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doGetDetailDoctorSpecialty(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateMedicalFacility = createAsyncThunk(
  "common/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doCreateMedicalFacility(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateMedicalFacility = createAsyncThunk(
  "common/update",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doUpdateMedicalFacility(payload);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListMedicalFacilityUser = createAsyncThunk(
  "common/list-medical-facility-user",
  async (_, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doGetListMedicalFacilityUser();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionDelMedicalFacilityUser = createAsyncThunk(
  "common/delete-medical-facility-user",
  async (data, { rejectWithValue }) => {
    try {
      const res = await SpecialtySliceService.doDelMedicalFacilityUser(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const specialtySlice = createSlice({
  name: "specialtySlice",
  initialState: {
    listSpecialty: {
      loading: false,
      data: null,
      error: "",
    },
    listMedicalFacility: {
      loading: false,
      data: null,
      error: "",
    },
    detailMedicalFacility: {
      loading: false,
      data: null,
      error: "",
    },
    detailDoctorSpecialty: {
      loading: false,
      data: null,
      error: "",
    },
    createMedicalFacility: {
      loading: false,
      data: null,
      error: "",
    },
    updateMedicalFacility: {
      loading: false,
      data: null,
      error: "",
    },
    listMedicalFacilityUser: {
      loading: false,
      data: null,
      error: "",
    },
    delMedicalFacilityUser: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // actionGetListSpecialty
      .addCase(actionGetListSpecialty.pending, (state) => {
        state.listSpecialty.loading = true;
      })
      .addCase(actionGetListSpecialty.fulfilled, (state, action) => {
        state.listSpecialty.loading = false;
        state.listSpecialty.data = action.payload;
      })
      .addCase(actionGetListSpecialty.rejected, (state, action) => {
        state.listSpecialty.loading = false;
        state.listSpecialty.data = action.payload;
        state.listSpecialty.error =
          action.error.message || "Something went wrong";
      })
      // actionGetListMedicalFacility
      .addCase(actionGetListMedicalFacility.pending, (state) => {
        state.listMedicalFacility.loading = true;
      })
      .addCase(actionGetListMedicalFacility.fulfilled, (state, action) => {
        state.listMedicalFacility.loading = false;
        state.listMedicalFacility.data = action.payload;
      })
      .addCase(actionGetListMedicalFacility.rejected, (state, action) => {
        state.listMedicalFacility.loading = false;
        state.listMedicalFacility.data = action.payload;
        state.listMedicalFacility.error =
          action.error.message || "Something went wrong";
      })
      // actionGetDetailMedicalFacility
      .addCase(actionGetDetailMedicalFacility.pending, (state) => {
        state.detailMedicalFacility.loading = true;
      })
      .addCase(actionGetDetailMedicalFacility.fulfilled, (state, action) => {
        state.detailMedicalFacility.loading = false;
        state.detailMedicalFacility.data = action.payload;
      })
      .addCase(actionGetDetailMedicalFacility.rejected, (state, action) => {
        state.detailMedicalFacility.loading = false;
        state.detailMedicalFacility.data = action.payload;
        state.detailMedicalFacility.error =
          action.error.message || "Something went wrong";
      })
      // detail doctor specialty
      .addCase(actionGetDetailDoctorSpecialty.pending, (state) => {
        state.detailDoctorSpecialty.loading = true;
      })
      .addCase(actionGetDetailDoctorSpecialty.fulfilled, (state, action) => {
        state.detailDoctorSpecialty.loading = false;
        state.detailDoctorSpecialty.data = action.payload;
      })
      .addCase(actionGetDetailDoctorSpecialty.rejected, (state, action) => {
        state.detailDoctorSpecialty.loading = false;
        state.detailDoctorSpecialty.data = action.payload;
        state.detailDoctorSpecialty.error =
          action.error.message || "Something went wrong";
      })
      // Create Medical Facility
      .addCase(actionCreateMedicalFacility.pending, (state) => {
        state.createMedicalFacility.loading = true;
      })
      .addCase(actionCreateMedicalFacility.fulfilled, (state, action) => {
        state.createMedicalFacility.loading = false;
        state.createMedicalFacility.data = action.payload;
      })
      .addCase(actionCreateMedicalFacility.rejected, (state, action) => {
        state.createMedicalFacility.loading = false;
        state.createMedicalFacility.data = action.payload;
        state.createMedicalFacility.error =
          action.error.message || "Something went wrong";
      })

      // update Medical Facility
      .addCase(actionUpdateMedicalFacility.pending, (state) => {
        state.updateMedicalFacility.loading = true;
      })
      .addCase(actionUpdateMedicalFacility.fulfilled, (state, action) => {
        state.updateMedicalFacility.loading = false;
        state.updateMedicalFacility.data = action.payload;
      })
      .addCase(actionUpdateMedicalFacility.rejected, (state, action) => {
        state.updateMedicalFacility.loading = false;
        state.updateMedicalFacility.data = action.payload;
        state.updateMedicalFacility.error =
          action.error.message || "Something went wrong";
      })
      // actionGetListMedicalFacilityUser
      .addCase(actionGetListMedicalFacilityUser.pending, (state) => {
        state.listMedicalFacilityUser.loading = true;
      })
      .addCase(actionGetListMedicalFacilityUser.fulfilled, (state, action) => {
        state.listMedicalFacilityUser.loading = false;
        state.listMedicalFacilityUser.data = action.payload;
      })
      .addCase(actionGetListMedicalFacilityUser.rejected, (state, action) => {
        state.listMedicalFacilityUser.loading = false;
        state.listMedicalFacilityUser.data = action.payload;
        state.listMedicalFacilityUser.error =
          action.error.message || "Something went wrong";
      })
      // actionDelMedicalFacilityUser
      .addCase(actionDelMedicalFacilityUser.pending, (state) => {
        state.delMedicalFacilityUser.loading = true;
      })
      .addCase(actionDelMedicalFacilityUser.fulfilled, (state, action) => {
        state.delMedicalFacilityUser.loading = false;
        state.delMedicalFacilityUser.data = action.payload;
      })
      .addCase(actionDelMedicalFacilityUser.rejected, (state, action) => {
        state.delMedicalFacilityUser.loading = false;
        state.delMedicalFacilityUser.data = action.payload;
        state.delMedicalFacilityUser.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default specialtySlice.reducer;
export const { actions, reducer } = specialtySlice;
